import env from 'environment';

/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const DEFAULT_LOCALE = 'en';


export const UPDATE_CDF = 'updateCDF';
export const SET_PPTX_CDF = 'ayda/App/CDF/setPptxCdf';
export const SET_CONTROL_LIST = 'setControlList';
export const GET_QUESTION_SUGGESTIONS = 'getQuestionSuggestions';
export const GET_PACKAGE = 'getPackage';
export const SET_PACKAGE = 'setPackage';
export const GET_USER = 'getUser';
export const SET_USER = 'setUser';
export const SET_ORG = 'setOrg';
export const SET_ROLE = 'setRole';
export const AUTHORISED_ROLES = ['ff_editor', 'ff_subscriber'];

export const UPDATE_QUESTION_SUGGESTIONS = 'updateQuestionSuggestions';
export const CREATE_QUESTION_CONTROL = 'createQuestionControl';
export const STORE_QUESTION_CONTROL_LIST = 'storeQuestionControlList';
export const STORE_META_JSON = 'storeMetaJSON';
export const SET_META_DATA = 'ayda/App/CDF/SetMetaData';
export const CREATE_CHART_CONTROL = 'createChartControl';
export const CREATE_TEMPORARY_CHART_CONTROL = 'ayda/App/Selector/createTempChartControl';
export const STORE_TEMPORARY_QUSTION_CONTROL_LIST = 'ayda/App/Selector/storeTempChartControl';

export const UPDATE_CLUSTER_LIST = 'ayda/App/Clusters/updateClusterList';
export const GET_PRESET_COUNTRY_LIST = 'ayda/App/Clusters/getPresetCountryList';
export const GET_PRESET_BREAK_LIST = 'ayda/App/Clusters/getPresetBreakList';
export const STORE_PRESET_CLUSTER_LISTS = 'ayda/App/Clusters/storePresetClusterList';
export const SET_PRESET_CLUSTER_CONTROL = 'ayda/App/Clusters/setPresetClusterControl';

export const IS_AUTHENTICATED = 'isAuthenticated';
export const GET_EXTERNAL_CDF = 'getExternalCdf';
export const PPTX_DOWNLOAD_START = 'ayda/App/PPTX_DOWNLOAD_START';
export const PPTX_DOWNLOAD_STOP = 'ayda/App/PPTX_DOWNLOAD_STOP';
export const PPTX_DOWNLOAD_READY = 'ayda/App/PPTX_DOWNLOAD_READY';
export const PPTX_DOWNLOAD_FAILED = 'ayda/App/PPTX_DOWNLOAD_FAILED';
export const DOWNLOAD_NOTIFICATION_CLOSED = 'ayda/App/DOWNLOAD_NOTIFICATION_CLOSED';
export const CSV_DOWNLOAD_READY = 'ayda/App/CSV_DOWNLOAD_READY';

export const CHART_LOADING = 'ayda/App/CHART_LOADING';
export const CHART_ERROR = 'ayda/App/CHART_ERROR';
export const SET_PAGE_LOADING = 'ayda/App/SET_PAGE_LOADING';

export const SET_SHOW_NEW_QUESTION = 'ayda/App/setShowNewQuestion';

export const NEW_CHART = 'ayda/App/newChart';
export const STORE_NEW_CHART = 'ayda/App/storeNewChart';

// Our hostname, used when setting the origin header
export const AYDA_UI_HOSTNAME = env.VIRTUAL_HOST || 'datatool-dev.foresightfactory.co:3000';
export const GRAPHQL_URL = env.GRAPHQL_FQDN_HTTPS || 'http://ayda-local.foresightfactory.co:8010/proxy/graphql';
// export const GRAPHQL_URL = 'http://localhost:5000/graphql';
export const PLATFORM_LOGIN_URL = env.NVISION_SIGN_IN_URL || 'https://staging-ffonline.foresightfactory.co/users/sign_in';
export const PLATFORM_URL = env.PLATFORM_URL || 'http://ffonline-local.foresightfactory.co:5000';
export const TYPEAHEAD_LIMIT = 10;
export const PPTX_DOWNLOAD_URL = env.PPTX_DOWNLOAD_URL || 'http://ayda-local.foresightfactory.co:9999/proxy/api/v1/pptx';
export const GA_ID = env.GA_ID;



// WEBPACK FOOTER //
// ./app/containers/App/constants.js